__turbopack_context__.v({
  "menuButton": "Vb9jHW_menuButton",
  "menuContent": "Vb9jHW_menuContent",
  "menuContent__text": "Vb9jHW_menuContent__text",
  "menuContent__timeline": "Vb9jHW_menuContent__timeline",
  "menuContent__timelineItem": "Vb9jHW_menuContent__timelineItem",
  "menuContent__timelineItemLink": "Vb9jHW_menuContent__timelineItemLink",
  "menuContent__title": "Vb9jHW_menuContent__title",
  "menuContent_footer": "Vb9jHW_menuContent_footer",
  "menuWrapper": "Vb9jHW_menuWrapper",
  "mouseBounce": "Vb9jHW_mouseBounce",
  "pageWrapper": "Vb9jHW_pageWrapper",
  "scrollButton": "Vb9jHW_scrollButton",
  "scrollButton_mouseBounce": "Vb9jHW_scrollButton_mouseBounce",
  "sectionContent_date": "Vb9jHW_sectionContent_date",
  "sectionContent_headline": "Vb9jHW_sectionContent_headline",
  "sectionContent_image": "Vb9jHW_sectionContent_image",
  "sectionContent_text": "Vb9jHW_sectionContent_text",
  "sectionContent_title": "Vb9jHW_sectionContent_title",
  "sectionContent_video": "Vb9jHW_sectionContent_video",
  "sectionQuote_images": "Vb9jHW_sectionQuote_images",
  "sectionQuote_scrollContainer": "Vb9jHW_sectionQuote_scrollContainer",
  "sectionQuote_wrapper": "Vb9jHW_sectionQuote_wrapper",
  "sectionWrapper": "Vb9jHW_sectionWrapper",
  "sectionWrapper_container": "Vb9jHW_sectionWrapper_container",
  "wheelContainer": "Vb9jHW_wheelContainer",
  "wheelSpin": "Vb9jHW_wheelSpin",
});
